module.exports = {"511323001":"周口街道","511323002":"相如街道","511323101":"锦屏镇","511323102":"巨龙镇","511323103":"正源镇","511323105":"金溪镇","511323106":"徐家镇","511323107":"河舒镇","511323108":"利溪镇","511323109":"龙蚕镇","511323110":"杨家镇","511323111":"罗家镇","511323112":"福德镇","511323113":"银汉镇","511323114":"兴旺镇","511323116":"睦坝镇","511323208":"平头乡","511323209":"鲜店乡","511323215":"金甲乡","511323217":"新园乡","511323222":"石孔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511323.json
// module id = 2476
// module chunks = 0